import React from "react";
import PageHeader from "../components/PageHeader";

const Privacy = () => {
  return (
    <div className="bg-dreibach-black min-h-screen pb-24">
      <PageHeader 
        title="Privacy Policy" 
        subtitle="Last Updated: January 2026"
        image="https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&q=80&w=2000"
      />
      <div className="container mx-auto px-6 py-24 max-w-4xl text-gray-300 space-y-8">
        <p>At Dreibach Ltd, we are committed to protecting your privacy and ensuring the security of your personal information.</p>
        <h3 className="text-xl font-bold text-white">1. Information We Collect</h3>
        <p>We collect information you provide directly to us, such as when you fill out a trade inquiry form, request access to our portal, or communicate with us via email.</p>
        <h3 className="text-xl font-bold text-white">2. How We Use Your Information</h3>
        <p>We use the information we collect to provide, maintain, and improve our services, including processing trade applications and managing partner relationships.</p>
        <h3 className="text-xl font-bold text-white">3. Contact Us</h3>
        <p>If you have any questions about this Privacy Policy, please contact us at trade@dreibachltd.com.</p>
      </div>
    </div>
  );
};

export default Privacy;
